<template>
  <div class="footerContainer">
    <div class="firstDiv">
      <img class="logo" :src="logo" alt="logo" />
      <p class="details">
        Prexange est une marketplace de dossiers de financement publiés par des sociétés de courtage, certifiés par nos
        analystes, un flux constant de dossiers à portée de main
      </p>
      <div class="signInBtn">
        <Icon class="icon" icon="fluent:arrow-right-24-regular" height="20" />
        <a href="https://us17.list-manage.com/contact-form?u=12eb10c034208fa73e5a394c1&form_id=3349a43f091cf8acd4ccbbef24d933e5" class="text" target="_blank" style="color: white; text-decoration: none;"><span>Demande d’inscription </span></a>
      </div>
    </div>
    <div class="secondDiv">
      <div class="iconsContainer">
        <Icon class="icon" icon="hugeicons:new-twitter" height="36" />
        <Icon class="icon" icon="bi:youtube" height="36" />
        <Icon class="icon" icon="jam:linkedin" height="36" />
      </div>
      <p class="details">
        © 2024 PREXANGE Tous droits réservés .
        <routerLink to="/conditions" class="text" style="color: white; text-decoration: none;"><span>Conditions d’utilisation</span></routerLink>
        <!-- <span>Politique de confidentialité</span> -->
        <routerLink to="/mentions" class="text" style="color: white; text-decoration: none;"><span>Mentions légales</span></routerLink>
      </p>
    </div>
  </div>
</template>

<script>
import logo from '@/assets/images/whiteLogo.png';
import { Icon } from '@iconify/vue2';

export default {
  name: 'footer',
  components: {
    Icon,
  },
  data() {
    return {
      logo: logo,
      isSidebarOpen: false,
    };
  },
};
</script>

<style lang="scss">
@import './footer.scss'
</style>